export { calculateNEWS2Score, calculateQuroScore } from './news2';
export { getOxygenSaturationScale } from './oxygen';
//# sourceMappingURL=index.js.map